import type { HeatmapScrollRowSelectFragment } from '../graphql/fragments/heatmapScrollRow.generated';
import type { HeatmapScrollData } from '~/types/graphql';

interface IHeatmapScrollRow extends HeatmapScrollRowSelectFragment {}

export interface IHeatmapScroll extends HeatmapScrollData {
  rows: IHeatmapScrollRow[];
}

export enum EHeatmapScrollTooltipKey {
  PERC_SCROLLED_DEPTH = 'PERC_SCROLLED_DEPTH',
  PERC_SCROLLED = 'PERC_SCROLLED',
  TOTAL_VISITOR = 'TOTAL_VISITOR',
  PERC_DROP_OFF = 'PERC_DROP_OFF',
  AVG_TIME_SPENT = 'AVG_TIME_SPENT',
  CONVERSION_RATE = 'CONVERSION_RATE',
  PERC_OF_SESSION_LENGTH = 'PERC_OF_SESSION_LENGTH',
  TOTAL_VISITORS_CONVERTED = 'TOTAL_VISITORS_CONVERTED',
  TOTAL_REVENUE = 'TOTAL_REVENUE',
}
